/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 7H15.5C16.8807 7 18 5.88071 18 4.5C18 3.11929 16.8807 2 15.5 2H15.4198C14.2803 2 13.2758 2.74741 12.9484 3.83881L12 7ZM12 7H8.5C7.11929 7 6 5.88071 6 4.5C6 3.11929 7.11929 2 8.5 2H8.58023C9.71968 2 10.7242 2.74741 11.0516 3.83881L12 7ZM12 7V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 11V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V11M4 11H20C21.1046 11 22 10.1046 22 9V9C22 7.89543 21.1046 7 20 7H4C2.89543 7 2 7.89543 2 9V9C2 10.1046 2.89543 11 4 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4 11H20V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V11Z"
				fill="currentColor"
			/>
			<path
				d="M20 11V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V11M12 7V22M12 7H15.5C16.8807 7 18 5.88071 18 4.5C18 3.11929 16.8807 2 15.5 2H15.4198C14.2803 2 13.2758 2.74741 12.9484 3.83881L12 7ZM12 7H8.5C7.11929 7 6 5.88071 6 4.5C6 3.11929 7.11929 2 8.5 2H8.58023C9.71968 2 10.7242 2.74741 11.0516 3.83881L12 7ZM4 11H20C21.1046 11 22 10.1046 22 9V9C22 7.89543 21.1046 7 20 7H4C2.89543 7 2 7.89543 2 9V9C2 10.1046 2.89543 11 4 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.75 4.5C6.75 3.5335 7.5335 2.75 8.5 2.75H8.58023C9.38847 2.75 10.101 3.28016 10.3333 4.05432L10.992 6.25H8.5C7.5335 6.25 6.75 5.4665 6.75 4.5ZM5.76091 6.25C5.4375 5.74485 5.25 5.14432 5.25 4.5C5.25 2.70507 6.70507 1.25 8.5 1.25H8.58023C10.0509 1.25 11.3474 2.21466 11.77 3.6233L12 4.38992L12.23 3.6233C12.6526 2.21466 13.9491 1.25 15.4198 1.25H15.5C17.2949 1.25 18.75 2.70507 18.75 4.5C18.75 5.14432 18.5625 5.74485 18.2391 6.25H20.5C21.7426 6.25 22.75 7.25736 22.75 8.5C22.75 9.74264 21.7426 10.75 20.5 10.75H3.5C2.25736 10.75 1.25 9.74264 1.25 8.5C1.25 7.25736 2.25736 6.25 3.5 6.25H5.76091ZM15.5 6.25C16.4665 6.25 17.25 5.4665 17.25 4.5C17.25 3.5335 16.4665 2.75 15.5 2.75H15.4198C14.6115 2.75 13.899 3.28016 13.6667 4.05432L13.008 6.25H15.5ZM11.2495 12.7282C11.25 12.7391 11.25 12.752 11.25 12.7778V16.25C11.25 16.6642 11.5858 17 12 17C12.4142 17 12.75 16.6642 12.75 16.25V12.7778C12.75 12.752 12.75 12.7391 12.7505 12.7282C12.7618 12.4692 12.9692 12.2618 13.2282 12.2505C13.2391 12.25 13.252 12.25 13.2778 12.25H19.95C20.23 12.25 20.37 12.25 20.477 12.3045C20.5711 12.3524 20.6476 12.4289 20.6955 12.523C20.75 12.63 20.75 12.77 20.75 13.05V16.35C20.75 18.5902 20.75 19.7103 20.314 20.566C19.9305 21.3186 19.3186 21.9305 18.566 22.314C17.7103 22.75 16.5902 22.75 14.35 22.75H9.65C7.40979 22.75 6.28968 22.75 5.43404 22.314C4.68139 21.9305 4.06947 21.3186 3.68597 20.566C3.25 19.7103 3.25 18.5902 3.25 16.35V13.05C3.25 12.77 3.25 12.63 3.3045 12.523C3.35243 12.4289 3.42892 12.3524 3.523 12.3045C3.62996 12.25 3.76997 12.25 4.05 12.25H10.7222C10.748 12.25 10.7609 12.25 10.7718 12.2505C11.0308 12.2618 11.2382 12.4692 11.2495 12.7282Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 11H4C2.89543 11 2 10.1046 2 9V9C2 7.89543 2.89543 7 4 7H20C21.1046 7 22 7.89543 22 9V9C22 10.1046 21.1046 11 20 11H12M20 11V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V11M12 7H15.5C16.8807 7 18 5.88071 18 4.5C18 4.32877 17.9828 4.16156 17.95 4M12 7L12.9484 3.83881C13.2758 2.74741 14.2803 2 15.4198 2H15.5M12 7H8.5C7.11929 7 6 5.88071 6 4.5C6 3.11929 7.11929 2 8.5 2H8.58023C9.71968 2 10.7242 2.74741 11.0516 3.83881L12 7ZM12 7V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M20 11V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V11M12 7V22M12 7H15.5C16.8807 7 18 5.88071 18 4.5C18 3.11929 16.8807 2 15.5 2H15.4198C14.2803 2 13.2758 2.74741 12.9484 3.83881L12 7ZM12 7H8.5C7.11929 7 6 5.88071 6 4.5C6 3.11929 7.11929 2 8.5 2H8.58023C9.71968 2 10.7242 2.74741 11.0516 3.83881L12 7ZM4 11H20C21.1046 11 22 10.1046 22 9V9C22 7.89543 21.1046 7 20 7H4C2.89543 7 2 7.89543 2 9V9C2 10.1046 2.89543 11 4 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 12.7778C11.25 12.752 11.25 12.7391 11.2495 12.7282C11.2382 12.4692 11.0308 12.2618 10.7718 12.2505C10.7609 12.25 10.748 12.25 10.7222 12.25H4.05C3.76997 12.25 3.62996 12.25 3.523 12.3045C3.42892 12.3524 3.35243 12.4289 3.3045 12.523C3.25 12.63 3.25 12.77 3.25 13.05V16.35C3.25 18.5902 3.25 19.7103 3.68597 20.566C4.06947 21.3186 4.68139 21.9305 5.43404 22.314C6.28969 22.75 7.40979 22.75 9.65 22.75H14.35C16.5902 22.75 17.7103 22.75 18.566 22.314C19.3186 21.9305 19.9305 21.3186 20.314 20.566C20.75 19.7103 20.75 18.5902 20.75 16.35V13.05C20.75 12.77 20.75 12.63 20.6955 12.523C20.6476 12.4289 20.5711 12.3524 20.477 12.3045C20.37 12.25 20.23 12.25 19.95 12.25H13.2778C13.252 12.25 13.2391 12.25 13.2282 12.2505C12.9692 12.2618 12.7618 12.4692 12.7505 12.7282C12.75 12.7391 12.75 12.752 12.75 12.7778V16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V12.7778Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.75 4.5C6.75 3.5335 7.5335 2.75 8.5 2.75H8.58023C9.38847 2.75 10.101 3.28016 10.3333 4.05432L10.992 6.25H8.5C7.5335 6.25 6.75 5.4665 6.75 4.5ZM5.76091 6.25C5.4375 5.74485 5.25 5.14432 5.25 4.5C5.25 2.70507 6.70507 1.25 8.5 1.25H8.58023C10.0509 1.25 11.3474 2.21466 11.77 3.6233L12 4.38992L12.23 3.6233C12.6526 2.21466 13.9491 1.25 15.4198 1.25H15.5C17.2949 1.25 18.75 2.70507 18.75 4.5C18.75 5.14432 18.5625 5.74485 18.2391 6.25H20.5C21.7426 6.25 22.75 7.25736 22.75 8.5C22.75 9.74264 21.7426 10.75 20.5 10.75H3.5C2.25736 10.75 1.25 9.74264 1.25 8.5C1.25 7.25736 2.25736 6.25 3.5 6.25H5.76091ZM15.5 6.25C16.4665 6.25 17.25 5.4665 17.25 4.5C17.25 3.5335 16.4665 2.75 15.5 2.75H15.4198C14.6115 2.75 13.899 3.28016 13.6667 4.05432L13.008 6.25H15.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
